module.exports = __webpack_public_path__ + "img/card7.c87964eb.jpg";